import YCol from './src/main'

YCol.install = function(Vue) {
  Vue.component(YCol.name, YCol)
}

export default YCol
